import { ApiClient } from "./clients";
import { SignatureVerificationResult } from "./models/signature/SignatureVerificationResult";

export class SignatureVerificationManager {
  constructor(private readonly apiClient: ApiClient) {}

  verify(payload: {
    signature: string;
    file: string;
  }): Promise<SignatureVerificationResult> {
    return this.apiClient.post("/verify", payload);
  }
}
